import Vue from 'vue'
import Router from 'vue-router'

const home = () => import('views/home/home.vue');
const search = () => import('views/home/search/search.vue');
const guide = () => import('views/home/guide/guide.vue');
const login = () => import('views/login/login.vue');
const loginForA = () => import('views/login/loginForA.vue');
const findPwd = () => import('views/login/findPwd/findPwd.vue');

const why = () => import('views/home/help/why.vue');
const know = () => import('views/home/help/know.vue');
const power = () => import('views/home/help/power.vue');


const layout = () => import('components/layout/layout.vue');

const caselist = () => import('views/caselist/caselist.vue');
const caselistForA = () => import('views/caselist/caselistForA.vue');

const details = () => import('views/caseDetails/caseDetails.vue');

// 操作界面
const pay = () => import('views/action/pay/pay.vue');
const wxpay = () => import('views/action/pay/wxpay.vue');
const success = () => import('views/action/pay/success.vue');
const proof = () => import('views/action/proof/proof.vue');
const examination = () => import('views/action/examination/examination.vue');
const question = () => import('views/action/question/question.vue');
const answer = () => import('views/action/answer/answer.vue');
const draft = () => import('views/action/draft/draft.vue');
//预览
const preView = () => import('views/action/draft/preView.vue');
const replyList = () => import('views/action/reply/replyList.vue');
const reply = () => import('views/action/reply/reply.vue');
const replyShow = () => import('views/action/reply/replyShow.vue');
const letterView = () => import('views/action/letter/letterView.vue');
const viewOtherSubmit = () => import('views/action/otherSubmit/viewOtherSubmit.vue');
const recode = () => import('views/action/recode/recode.vue');
//  站内信
const message = () => import('views/message');


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: loginForA
    },
    {
      path: '/login',
      meta: {
        isStatic: true
      },
      name: 'login',
      component: loginForA
    },
    {
      path: '/arbitor/login',
      meta: {
        isStatic: true
      },
      name: 'loginForA',
      component: loginForA
    },
    //预览
    {
      path: '/case/preView',
      name: 'preView',
      component: preView
    },
    {
      path: '/layout',
      component: layout,
      redirect: '/',
      children: [
        {
          path: '/findPwd',
          meta: {
            isStatic: true
          },
          component: findPwd
        },
        {
          path: '/arbitor/findPwd',
          meta: {
            isStatic: true
          },
          component: findPwd
        },
        // {
        //   path: '/home',
        //   meta: {
        //     isStatic: true
        //   },
        //   component: loginForA
        // },
        {
          path: '/search',
          meta: {
            isStatic: true
          },
          component: search
        },
        {
          path: '/guide',
          meta: {
            isStatic: true
          },
          name: 'guide',
          component: guide
        },
        {
          path: '/guide/why',
          meta: {
            isStatic: true
          },
          name: 'why',
          component: why
        },
        {
          path: '/guide/know',
          meta: {
            isStatic: true
          },
          name: 'know',
          component: know
        },
        {
          path: '/guide/power',
          meta: {
            isStatic: true
          },
          name: 'power',
          component: power
        },
        {
          path: '/caselist',
          component: caselist
        },
        {
          path: '/arbitor/caselist',
          component: caselistForA
        },
        {
          path: '/caselist/details',
          name: 'details',
          component: details
        },
        {
          path: '/caselist/letterView',
          name: 'letterView',
          component: letterView
        },
        {
          path: '/caselist/otherSubmit/view',
          name: 'viewOtherSubmit',
          component: viewOtherSubmit
        },
        {
          path: '/caselist/pay',
          name: 'pay',
          component: pay
        },
        {
          path: '/caselist/pay/success',
          name: 'success',
          component: success
        },
        {
          path: '/caselist/pay/wxpay',
          name: 'wxpay',
          component: wxpay
        },
        {
          path: '/caselist/proof',
          name: 'proof',
          component: proof
        },
        {
          path: '/caselist/examination',
          name: 'examination',
          component: examination
        },
        {
          path: '/caselist/question',
          name: 'question',
          component: question
        },
        {
          path: '/caselist/answer',
          name: 'answer',
          component: answer
        },
        {
          path: '/caselist/draft',
          name: 'draft',
          component: draft
        },
        {
          path: '/caselist/recode',
          name: 'recode',
          component: recode
        },
        {
          path: '/caselist/draft/edit',
          name: 'editDraft',
          component: draft
        },
        {
          path: '/caselist/draft/signet',
          name: 'signetDraft',
          component: draft
        },
        {
          path: '/caselist/replyList',
          name: 'replyList',
          component: replyList
        },
        {
          path: '/caselist/replyList/reply',
          name: 'reply',
          component: reply
        },
        {
          path: '/caselist/replyList/show',
          name: 'replyShow',
          component: replyShow
        },
        {
          path: '/message',
          name: 'message',
          component: message
        },
      ]
    },
  ]
});


// WEBPACK FOOTER //
// ./src/router/index.js